import { render, staticRenderFns } from "./Dianpu.vue?vue&type=template&id=4fa72446&scoped=true"
import script from "./Dianpu.vue?vue&type=script&lang=js"
export * from "./Dianpu.vue?vue&type=script&lang=js"
import style0 from "./Dianpu.vue?vue&type=style&index=0&id=4fa72446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa72446",
  null
  
)

export default component.exports